/* eslint-disable */
export default {
  init() {
    // JavaScript to be fired on the home page

  },
  finalize() {
    // JavaScript to be fired on the home page, after the init JS
    $('.gallery-owl').owlCarousel({
      loop: true,
      margin: 10,
      nav: true,
      responsive: {
        0: {
          items: 1
        },
        600: {
          items: 1
        },
        1000: {
          items: 1
        }
      }
    })
    $('.fab-next').mouseup(function () {
      let uid = $(this).data('uid');
      // $(`div[data-uid="${uid}"]`).trigger('next.owl.carousel');
      var carousel = $(this).closest('.owl-carousel')
      $(carousel).trigger('next.owl.carousel');
    });
    $('.fab-prev').mouseup(function () {
      let uid = $(this).data('uid');
      $(`div[data-uid="${uid}"]`).trigger('prev.owl.carousel');
    });

    // FAQ
    $('.faq-btn').click(function () {
      const $this = $(this);
      const $target = $($this.data('target'));

      $('.faq-btn').each(function () {
        if (this !== $this.get()[0]) {
          $(this).find('.icon-wrap .faq-icon').removeClass('icon-faq-minus').addClass('icon-faq-plus');
          $($(this).data('target')).slideUp(300);
        }
      });

      $target.slideToggle(300);
      $this.find('.icon-wrap .faq-icon').toggleClass('icon-faq-plus').toggleClass('icon-faq-minus');
    })
  },
};



// WEBPACK FOOTER //
// ./scripts/routes/template-flexi-default.js